import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { PieChart } from "../../../common/ReusableComponent/Chart";
import "./GasData.css";

function CustomerData({ latest_companies = [], paid_unpaid_stats_for_house_charges = {} }) {
  const [paymentStatusChartData, setPaymentStatusChartData] = useState(null);

  useEffect(() => {
    if (paid_unpaid_stats_for_house_charges) {
      setPaymentStatusChartData({
        labels: ["Paid", "Unpaid"],
        datasets: [
          {
            label: "Payment Status",
            data: [
              paid_unpaid_stats_for_house_charges.paid_percent || 0,
              paid_unpaid_stats_for_house_charges.unpaid_percent || 0,
            ],
            backgroundColor: ["#4CAF50", "#F44336"],
          },
        ],
      });
    }
  }, [paid_unpaid_stats_for_house_charges]);

  return (
    <>
      <div className="pie-chart-container" style={{marginBottom: "20px", height: "220px"}}>
        {paymentStatusChartData && paymentStatusChartData.datasets[0].data.some((value) => value > 0) ? (
          <PieChart
            labels={paymentStatusChartData.labels}
            datasets={paymentStatusChartData.datasets}
            title="Paid vs Unpaid House Charges"
            legendPosition="right"
            noBorder
            noShadow
          />
        ) : (
          <div className="no-data-message">No data found for payment status</div>
        )}
      </div>

      {latest_companies.length > 0 && (
        <div className="new-customers-table" style={{marginTop: "10px", textAlign: "center"}}>
          <h4 style={{fontFamily: "Arial", fontSize: "16px", fontWeight: "600", marginBottom: "10px"}}>List of New Companies</h4>
          <Table style={{ marginTop: "10px" }}>
            <TableHead>
              <TableRow>
                <TableCell style={{ padding: "10px" }}>Name</TableCell>
                <TableCell style={{ padding: "10px" }}>Email</TableCell>
                <TableCell style={{ padding: "10px" }}>Contact No</TableCell>
                <TableCell style={{ padding: "10px" }}>Join Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {latest_companies.map((company, index) => (
                <TableRow key={index}>
                  <TableCell style={{ padding: "10px" }}>{company.name}</TableCell>
                  <TableCell style={{ padding: "10px" }}>{company.email}</TableCell>
                  <TableCell style={{ padding: "10px" }}>{company.contact_no}</TableCell>
                  <TableCell style={{ padding: "10px" }}>{company.date}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
      {latest_companies.length === 0 && (
        <div className="no-data-message" style={{marginTop: "10px"}}>No data available</div>
      )}
    </>
  );
}

export default CustomerData;